export default function trim(value: string, what: string): string {
	let start = 0
	let end = value.length

	while (start < end && what.includes(value[start])) {
		start += 1
	}

	while (end > start && what.includes(value[end - 1])) {
		end -= 1
	}

	return start > 0 || end < value.length ? value.substring(start, end) : value
}
